module.exports = __webpack_public_path__ + "img/icoin-deposit-withdrawal.0913f16e.png";